import React, { useContext } from 'react';
import DefaultLayout from '../../DefaultLayout/DefaultLayout';
import ContentBox from '../../common/ContentBox/ContentBox';
import useCustomersHook from './Customers.hook';
import { Table, Modal, Button, Popover, Tag } from 'antd';
import { AppContext } from 'App.context';
import { capitalize } from 'utils/TextUtils';
import AppButton from 'Components/common/Forms/AppButton/AppButton';
import styles from './Customers.styles';
import Icon, { DeleteOutlined } from '@ant-design/icons';
import Colors from 'constants/Colors';
import { ReactComponent as activeDot } from 'assets/images/activeDot.svg';
import { ReactComponent as inactiveDot } from 'assets/images/inactiveDot.svg';
import { ReactComponent as blockDot } from 'assets/images/blockDot.svg';
import AddClientModal from './modals/AddCustomerModal';
import DeleteClientModal from './modals/DeleteCustomerModal';

export default function Customers() {
  const { state, actions } = useCustomersHook();
  const {
    appState,
    appActions: { translate },
  } = useContext(AppContext);

  const columns = [
    {
      title: translate('customers.customersDetail.name'),
      dataIndex: 'name',
      key: 'name',
      render: (_, row) => {
        return (
          <div style={row.isBlockedUser ? { color: Colors.redDesactivedText } : null}>
            {capitalize(row.name)}
          </div>
        );
      },
    },
    {
      title: translate('customers.customersDetail.email'),
      dataIndex: 'email',
      key: 'email',
      render: (_, row) => {
        return (
          <div style={row.isBlockedUser ? { color: Colors.redDesactivedText } : null}>
            {capitalize(row.email)}
          </div>
        );
      },
    },
    {
      title: translate('customers.customersDetail.phone'),
      dataIndex: 'phone',
      key: 'phone',
      render: (_, row) => {
        return (
          <div style={row.isBlockedUser ? { color: Colors.redDesactivedText } : null}>
            {capitalize(row.phone)}
          </div>
        );
      },
    },
    {
      title: translate('customers.customersDetail.status'),
      key: 'status',
      dataIndex: 'status',
      render: (_, row) => {
        if (row.status == 'active' && !row.isBlockedUser) {
          return (
            <Tag style={styles.activeStatus} icon={<Icon component={activeDot} />}>
              {translate('customers.customersDetail.statusType.activeStatus')}
            </Tag>
          );
        }
        if (row.status == 'disabled') {
          return (
            <Tag style={styles.pendingStatus} icon={<Icon component={inactiveDot} />}>
              {translate('customers.customersDetail.statusType.pendingStatus')}
            </Tag>
          );
        }
        if (row.isBlockedUser) {
          return (
            <Tag style={styles.blockedStatus} icon={<Icon component={blockDot} />}>
              {translate('customers.customersDetail.statusType.blockedStatus')}
            </Tag>
          );
        }
      },
    },
    // {
    //   title: translate('customers.customersDetail.lastAccessDate'),
    //   dataIndex: 'lastAccessDate',
    //   key: 'lastAccessDate',
    //   render: (_, row) => {
    //     return (
    //       <div style={row.isBlockedUser ? { color: Colors.redDesactivedText } : null}>
    //         {capitalize(row.lastAccessDate)}
    //       </div>
    //     );
    //   },
    // },
    {
      title: translate('customers.customersDetail.action'),
      dataIndex: null,
      key: 'action',
      align: 'center',
      render: (_, row) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
            <Popover
              content={translate('customers.customersDetail.deleteCustomer.delete')}
              trigger="hover"
            >
              <Button
                type="secondary"
                icon={<DeleteOutlined />}
                disabled={!appState.superUser}
                onClick={() => actions.openDeleteUserModal(row.id)}
              />
            </Popover>
          </div>
        );
      },
    },
  ];

  return (
    <DefaultLayout title={translate('layout.customers')}>
      <div style={{ width: '100%' }}>
        <div style={styles.topButtonContainer}>
          <AppButton
            style={{ width: '155px' }}
            text={translate('customers.addCustomers')}
            action={() => actions.setModalState('isCreateModalVisible', true)}
            disabled={state.isLoading}
          />
        </div>
        <div style={{ marginTop: 0 }}>
          <ContentBox noPadding customMinSize={24}>
            <Table
              isLoading={state.isLoading}
              dataSource={state.customers}
              columns={columns}
              pagination={4}
            />
          </ContentBox>
        </div>
      </div>

      <Modal
        open={state.isCreateModalVisible}
        onCancel={() => actions.setModalState('isCreateModalVisible', false)}
        footer={null}
        width={521}
        height={391}
      >
        <AddClientModal actions={actions} state={state} />
      </Modal>

      <Modal
        open={state.isDeleteModalVisible}
        onCancel={actions.closeDeleteUserModal}
        footer={null}
        width={521}
        height={391}
      >
        <DeleteClientModal actions={actions} state={state} />
      </Modal>
    </DefaultLayout>
  );
}
